import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import { Link, useParams, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { InputImage } from "../../../Layout/Forms/Form";
import EventFormRequest from "./EventFormRequest";
import Loading from "../../../../components/Loading";

const FormFloorImage = ({ show, handleModalShow, handleModalhide, id }) => {
    const [isLoading, setIsLoading] = useState(false);
    let params = useParams();
    const [state, setState] = useState({
        form: {
            imageUrl: null,
            imageInput: null
        }
    })

    useEffect(() => {
        if (show) {
            getInfoFloorImage()
        }
    }, [show])


    const getInfoFloorImage = async () => {
        setIsLoading(true);
        let info = await EventFormRequest.getFloorImage({ image: state.form.imageInput, id_events: params.id });
        if (info && info.status) {
            setIsLoading(false);
            setState({
                ...state,
                form: {
                    imageUrl: info.data,
                    imageInput: ""
                }
            })
        } else {

        }
        setIsLoading(false);
    }

    const handleSubmitForm = async () => {
        setIsLoading(true);
        let info = await EventFormRequest.saveFloorImage({ image: state.form.imageInput, id_events: params.id });
        if (info && info.status) {
            setIsLoading(false);
            setState({
                ...state,
                form: {
                    imageUrl: info.data.image,
                    imageInput: ""
                }
            })
        } else {

        }
        setIsLoading(false);
    }

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    return (
        <>
            <Modal show={show} onHide={handleModalhide}>
                <Modal.Header closeButton>
                    <Modal.Title>Planta</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {isLoading ? <Loading /> : (
                        <div className="row">
                            <div className="col-8">
                                <InputImage
                                    label="Imagem (1020x1080)"
                                    name="imageInput"
                                    value={state.form.imageUrl}
                                    onChange={(e) => handleChangeInputs({ target: { name: "imageInput", value: e } })}
                                    errors={state.errors}
                                />
                                <button type="button" style={{ display: state.form.imageInput ? 'initial' : 'none' }} className="btn btn-primary w-100" onClick={handleSubmitForm}><i className="fa-solid fa-cloud-arrow-up me-3"></i>Upload</button>
                            </div>
                        </div>
                    )}

                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                    {/* <Button variant="primary" onClick={handleSubmitForm}>
                        Guardar
                    </Button> */}
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer /> */}
        </>
    )
}

export default FormFloorImage;